<template>
  <div id="vueApp" class>
    <app-header v-show="$store.getters.getPerfil === 'ADMINISTRADOR'" />

    <!--center> Menú operador </center-->

    <app-header-operario
      v-if="
        $store.getters.getPerfil === 'USUARIO' || 
        ($store.getters.getPerfil === 'ADMINISTRADOR' && 
        ($route.name === 'home' || $route.name === 'preguntas'))" 
      :tagsList="$store.getters.getTasks"
      :filterCategory="$store.getters.getFilterCategory"
      @keyup.enter="disabledEnter"
    />

    <router-view></router-view>

    <AppFooter />
  </div>
</template>

<script>
/* imports de componentes a usar */

import {  
  getCredentials
} from "./api/conection";

import AppHeader from "./components/Header.vue";
import AppHeaderOperario from "./components/HeaderOperario.vue";
import AppFooter from "./components/Footer.vue";
import { api_fetch} from "./api/conection";

export default {
  name: "app",
  components: {
    AppHeader,
    AppHeaderOperario,
    AppFooter
  },
  data() {
    return {
      info: null,
      loading: true,
      errored: false,
      isOperario: false
    };
  },
  mounted() {   
    /** TODO tiene que estar dentro del header */ 
    /*
      getAllCategories()
      .then(categories => {
        console.log(this.$route.name);
        if (!categories.message)
          this.$store.dispatch("setCategoriesAction", categories);
      })
      .catch(err => {
        console.log(err);
      });
      */
    //this.$store.getters.authenticating ? getCredentials().then((result) => {!result.perfil ? router.push("/Login") : 0 }).catch((e) => { console.log(e) }) : 0
  },
  methods: {
    disabledEnter() {
      return false;
    },
    
  }
};
</script>

<style>
@import "./styles/styles.css";
@import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
</style>
